import Resource from './resource-class'

class ExtractionMethodAPI extends Resource {
  constructor () {
    super()
    this.resource = '/extract_extraction_method'
  }
}

export default new ExtractionMethodAPI()
